import { Checkbox, DataSource, TableRowDisplayEvent } from "@mcleod/components";
import {
    AutogenLayoutBrokerageWorkflowProfileNextStatusSlideout
} from "./autogen/AutogenLayoutBrokerageWorkflowProfileNextStatusSlideout";

export class BrokerageWorkflowProfileNextStatusSlideout extends AutogenLayoutBrokerageWorkflowProfileNextStatusSlideout
{
    private _selectedStatusCodes = "";
    private _brokerage_status_code = "";
    private _can_be_changed_to = "";

    initialize(isSlideIn: boolean, brokerageStatusCode: string, canBeChangedTo: string, detailDataSource: DataSource) {
        this._brokerage_status_code = brokerageStatusCode;
        this._can_be_changed_to = canBeChangedTo;
        this.mainDataSource.search({ brokerage_status_code: this._brokerage_status_code, can_be_changed_to: this._can_be_changed_to });
        this.mainDataSource.orderBy = [{ field: "is_enabled", sort: "desc" }, {field: "descr", sort: "asc" }];
    }

    get selectedStatusCodes(): string {
        return this._selectedStatusCodes;
    }

    checkboxItemOnChange() {
        this.calculateSelectedCodes();
    }

    calculateSelectedCodes() {
        const builder = [];
        this.mainDataSource.data.forEach(row => {
            if (row.get("is_enabled") === "Y" ) {
                builder.push( row.get("id"));
            }
        })
        const newValue = builder.join(", ");
        this._selectedStatusCodes = newValue;
    }

    tableStatusCodesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const checkboxItem = event.target.findComponentById("checkboxItem") as Checkbox;
        checkboxItem.caption = event.getTableRow().data.get("id");
    }

 }
